module.exports = "/work-site/img/header_logo.7a018be0.png";